
import { defineComponent } from "vue";

export default defineComponent({
  methods: {
    renderCompanyItems() {
      return (
        <div class="footer-info__companies flex flex-col items-center">
          <div class="flex justify-between">
            <img
              src={require("./assets/company/asia-gaming.png")}
              alt="AVIA GAMING"
            />
            <img
              src={require("./assets/company/fb-sports.png")}
              alt="FB SPORTS"
            />
            <img
              src={require("./assets/company/db-gaming.png")}
              alt="DB GAMING"
            />
            <img
              src={require("./assets/company/inplay-matrix.png")}
              alt="INPLAY MATRIX"
            />
            <img
              src={require("./assets/company/pocket-games-soft.png")}
              alt="PG POCKET GAMES SOFT  "
            />
            <img src={require("./assets/company/bbin.png")} alt="bbin" />
          </div>
          <div class="flex justify-between">
            <img
              src={require("./assets/company/kaiyuan-gaming.png")}
              alt="Kaiyuan Gaming"
            />
            <img src={require("./assets/company/cq9.png")} alt="CQ9" />
            <img
              src={require("./assets/company/tc-gaming.png")}
              alt="TC GAMING"
            />
            <img
              src={require("./assets/company/vr-gaming.png")}
              alt="VR GAMING VIDEO RACING"
            />
            <img
              src={require("./assets/company/bole-gaming.png")}
              alt="BOLE GAMING"
            />
            <img
              src={require("./assets/company/ks-e-sports.png")}
              alt="AVIA GAMING"
            />
          </div>
        </div>
      );
    },
    renderInfoBar() {
      return (
        <div class="footer-info__info-bar px-20">
          <div class="flex justify-between">
            <div class="footer-info__license">
              <div class="footer-info__license-img-box">
                <img
                  class="footer-info__mga block"
                  src={require("./assets/bottom/mga.png")}
                  alt="mga MALTA GAMING AUTHORITY"
                />
              </div>
              <div class="footer-info__license-info">
                马尔他博彩牌照 (MGA) 认证
              </div>
            </div>
            <div class="footer-info__license">
              <div class="footer-info__license-img-box">
                <img
                  class="footer-info__pagcor block"
                  src={require("./assets/bottom/pagcor.png")}
                  alt="PAGCOR "
                />
              </div>
              <div class="footer-info__license-info">
                菲律賓 (PAGCOR) 監督牌照
              </div>
            </div>
            <div class="footer-info__license">
              <div class="footer-info__license-img-box">
                <img
                  class="footer-info__bvi block"
                  src={require("./assets/bottom/bvi.png")}
                  alt="British Vergin Islands Financial Services Commision"
                />
              </div>
              <div class="footer-info__license-info">
                英屬維京群島 (bvi) 認證
              </div>
            </div>
          </div>
          <div class="leading-normal mt-6">
            B体育拥有欧洲马耳他博彩管理局（MGA）和菲律宾博彩委员会（PAGCOR）颁发的合法执照；注册于英属维尔京群岛，是受国际博彩协会认可的合法博彩公司。进行注册并娱乐前，请确保您年满18周岁！
          </div>
        </div>
      );
    },
    renderBottom() {
      return (
        <div class="footer-info__bottom flex justify-between">
          {this.renderInfoBar()}
        </div>
      );
    },
  },
  render() {
    return (
      <div class="footer-info pb-5">
        {this.renderCompanyItems()}
        {this.renderBottom()}
      </div>
    );
  },
});
